import { setLoading } from "context";
import { useMaterialUIController } from "context";
import { getCooperate } from "controllers/UserController";
import { useEffect, useRef, useState } from "react";
// import "react-phone-input-2/lib/style.css";
import getText from "Translator";
import Swal from "sweetalert2";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Drawer,
  Grid,
  FormControlLabel,
  Switch,
  TextField,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import HighlightOffOutlinedIcon from "@mui/icons-material/HighlightOffOutlined";
import { removeCooperate } from "controllers/UserController";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { setHeader } from "context";
import { setAction } from "context";
import { registerCooperate } from "controllers/UserController";

export default function CooperateList(props) {
  const [datas, setDatas] = useState();
  const [open, setOpen] = useState(false);
  const [cellphone, setCellphone] = useState("");
  const [email, setEmail] = useState("");
  const [mode, setMode] = useState("assistant");

  const myRef = useRef(null);
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    getDatas();

    if (myRef.current !== null) {
      myRef.current.scrollIntoView();
    }
  }, []);
  useEffect(() => {
    (async () => {
      if (controller.action) {
        if (controller.action.startsWith("cooperate")) {
          setOpen(true);
        }
      }
      if (myRef.current !== null) {
        setAction(dispatch, "");
        myRef.current.scrollIntoView();
      }
    })();
  }, [controller.action]);
  const getDatas = async () => {
    try {
      setHeader(dispatch, "cooperate");
      setLoading(dispatch, true);

      let result = await getCooperate(controller);
      setLoading(dispatch, false);

      if (result.success) {
        setDatas(result.data);
      } else {
        Swal.fire({
          title: getText("warning", "fa"),
          text: result.message,
          confirmButtonText: getText("ok", "fa"),
          icon: "error",
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  //#region validationInfo
  let isValid = true;
  let message = "";

  const validationInfo = () => {
    // if (!validator.isEmail(email)) {
    //   isValid = false;
    //   message = message + getText("emailformat", "fa") + "<br>";
    // }

    if (cellphone.length < 11) {
      isValid = false;
      message = message + getText("cellformat", "fa") + "<br>";
    }

    return isValid;
  };
  //#endregion
  const submitHandler = async () => {
    try {
      if (!validationInfo()) {
        Swal.fire({
          title: "",
          html: message,
          confirmButtonText: getText("ok", "fa"),
          color: "red",
          icon: "error",
        });
        return;
      }
      setLoading(dispatch, true);
      let newUser = {
        userRole: mode,
        cellphone,
        email,
        lang: "fa",
      };

      let result = await registerCooperate(newUser, controller);
      setLoading(dispatch, false);
      if (result.success) {
        Swal.fire({
          title: "",
          text: result.message,
          icon: "success",
          confirmButtonText: getText("ok", "fa"),
        });
        getDatas();
        setOpen(false);
      } else {
        Swal.fire({
          title: getText("warning", "fa"),
          text: result.message,
          confirmButtonText: getText("ok", "fa"),
          icon: "error",
        });
      }
    } catch (err) {
      Swal.fire({
        title: "",
        text: getText("warning", "fa"),
        confirmButtonText: getText("ok", "fa"),
        icon: "error",
      });
      setLoading(dispatch, false);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar title={getText("cooperate", "fa")} />
      <div className={"fa" === "en" ? "listmenu" : "listmenu rtl"}>
        <List>
          {datas &&
            datas.map((item) => (
              <>
                <ListItem className="list" button key={item.id}>
                  <ListItemText
                    primary={
                      item.name +
                      " ( " +
                      (item.role === "assistant"
                        ? getText("assistant", "fa")
                        : getText("secretary", "fa")) +
                      " )"
                    }
                  />
                  <ListItemIcon
                    style={{ width: 35, minWidth: 35 }}
                    onClick={() => {
                      Swal.fire({
                        title: getText("warning", "fa"),
                        text: getText("deleteconfirm", "fa"),
                        confirmButtonText: getText("yes", "fa"),
                        cancelButtonText: getText("no", "fa"),

                        showCancelButton: true,
                      }).then(async (result) => {
                        if (result.isConfirmed) {
                          let newData = {
                            id: item.id,
                          };
                          let visibleResult = await removeCooperate(
                            newData,
                            controller
                          );
                          if (visibleResult.success) {
                            Swal.fire({
                              text: getText("alertsuccess", "fa"),
                              position: "bottom-end",
                              background: "#03fca1",
                              showConfirmButton: false,
                              timer: 1500,
                            });
                            getDatas();
                          } else {
                            Swal.fire({
                              text: getText("warningalert", "fa"),
                              position: "bottom-end",
                              background: "#f1b3af",
                              showConfirmButton: false,
                              timer: 1500,
                            });
                          }
                        } else {
                        }
                      });
                    }}
                  >
                    <DeleteOutlineIcon
                      style={{ fontSize: 20, color: "#039dfc" }}
                    />
                  </ListItemIcon>
                </ListItem>
                <Divider />
              </>
            ))}
        </List>

        <div style={{ width: "100%", height: 50 }}></div>
      </div>
      <Drawer
        anchor="bottom"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="drawertitle">
          <IconButton
            style={{
              color: "#FFF",
              height: 35,
              width: 35,
              top: 5,
              position: "absolute",
              right: 5,
            }}
            aria-label="HighlightOffOutlinedIcon"
            onClick={() => {
              setOpen(false);
            }}
          >
            <HighlightOffOutlinedIcon />
          </IconButton>
        </div>
        <Grid container p={3}>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  onChange={(event) => {
                    setMode("assistant");
                  }}
                  trackColor="#039dfc"
                  checked={mode === "assistant" ? true : false}
                />
              }
              label={getText("assistant", "fa")}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sm={6}
            md={6}
            style={{
              padding: 8,
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  onChange={(event) => {
                    setMode("secretary");
                  }}
                  trackColor="#039dfc"
                  checked={mode === "secretary" ? true : false}
                />
              }
              label={getText("secretary", "fa")}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              marginTop: 15,
            }}
          >
            {/* <PhoneInput
              country={"us"}
              value={cellphone}
              enableSearch
              onChange={(phone) => setCellphone(phone)}
            /> */}
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              type="tel"
              variant="outlined"
              label={getText("entercellasusernamecoop", "fa")}
              id="cellphone"
              fullWidth={true}
              value={cellphone}
              onChange={(event) => {
                setCellphone(event.target.value);
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            style={{
              marginTop: 15,
            }}
          >
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              label={getText("email", "fa")}
              id="email"
              fullWidth={true}
              value={email}
              onChange={(event) => {
                setEmail(event.target.value);
              }}
              variant="outlined"
            />
          </Grid>

          <Grid
            item
            key={"submit"}
            xs={12}
            sm={12}
            md={12}
            style={{
              marginTop: 20,
            }}
          >
            <Button
              color="primary"
              onClick={() => {
                submitHandler();
              }}
              fullWidth={true}
            >
              {getText("submit", "fa")}
            </Button>
          </Grid>
        </Grid>
      </Drawer>
      <Footer />
    </DashboardLayout>
  );
}
